import React from 'react';

function PercentageBars(props) {
    const probInc = Math.floor(props.probability[0] * 100);
    const probDec = Math.floor(props.probability[1] * 100);

    const mobile = props.mobile ? props.mobile : false;
    const increase = !!(props.statement === 'increase');

    const offset = mobile ? 14 : 50;

    const Bar = (color, prob) => (
        <div className={`bar ${color}`} style={{ width: `calc(${prob}% - ${offset}px)` }}>
            <div className="label">{`${prob}`}%</div>
        </div>
    );

    return (
        <>
            <div className="bars-container">
                {mobile ? increase ? Bar('green', probInc) : <></> : Bar('green', probInc)}
                {mobile ? !increase ? Bar('purple', probDec) : <></> : Bar('purple', probDec)}
            </div>
        </>
    );
}

export default PercentageBars;
